function defineTogglePassword() {

    const about = x => {
        let t = Object.prototype.toString.call(x).replace(/[\[\]]/g, '').split(' ');
        let r = {
          __proto: null,
          __type: t[1],
          object: t[0],
          type: t[1].toLowerCase()
        };
        if(/(?:null|undefined)/ig.test(t[1])) { return r };
        if(x instanceof Object) {
          r.__proto = "Object";
          if(x.constructor) { r.__type = x.constructor.name; }
        }else {
          r.__proto = Object.getPrototypeOf(x);
        }
        return r;
    };

      
    if (!Element.prototype.toggle) {
        /**
         * This method toggles whether the current element is shown or hidden
         * with either the use of the HTML5 "hidden" attribute or fading
         */
        Element.prototype.toggle = function (options) {
          let _settings = {
            fade: false,
            fadeOutDuration: 150,
            fadeInDuration: 300,
          };
          let _t = about(options).type;
          switch (_t) {
            case "boolean":
              _settings.fade = options;
              break;
            case "number":
              _settings = {
                fade: true,
                fadeInDuration: options,
                fadeOutDuration: options / 2
              }
              break;
            case "array":
              _settings.fade = true;
              if (options.length > 1) {
                _settings.fadeInDuration = options[0];
                _settings.fadeOutDuration = options[1];
                break;
              }
              _settings.fadeInDuration = options[0];
              _settings.fadeOutDuration = options[0] / 2;
              break;
            case "object":
              _settings = Object.assign(_settings, options);
              break;
            default:
              console.log(`Found argment of invalid type '${_t}' for Element.prototype.toggle method.`);
              break;
          }
          if (!_settings.fade) {
            this.hidden = !this.hidden;
          } else {
            this.isVisible ? this.fadeOut(_settings.fadeOutDuration) : this.fadeIn(_settings.fadeInDuration);
          }
        };
    }

    // toggle passwrd show/hide 
    if (!NodeList.prototype.togglePassword) {
        NodeList.prototype.togglePassword = function () {
            let input, btn, confirm;

            this.forEach(els => {
                Array.from(els.children).forEach(el => {
                    if (el.hasAttribute('data-toggle-password-input')) {
                        input = el;
                    }
                    if (el.hasAttribute('data-toggle-password-btn')) {
                        btn = el;
                    }
                });

                if (els.parentElement.nextElementSibling) {
                    Array.from(els.parentElement.nextElementSibling.getElementsByTagName('input')).forEach(el => {
                        if (el.hasAttribute('data-toggle-password-confirm-input')) {
                            confirm = el;
                        }
                    });
                }
            });

            if (input && btn) {
                btn.addEventListener('click', e => {
                    e.preventDefault();
                    toggle(input);
                    if (!confirm) return;
                    toggle(confirm);
                });
            }

            function toggle(input) {
                input.parentElement.querySelectorAll('img').forEach(img => img.toggle(false));
                if (input.getAttribute('type') === 'password') {
                    input.setAttribute('type', 'text');
                    return;
                }
                input.setAttribute('type', 'password');
            }
        };
    }
}

defineTogglePassword();
